<template>
	<div data-tour-scope="tickets">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Ticket</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-btn elevation="0" text data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-col cols="12">
							<v-row align="center">
								<v-col cols="12" md="4" data-tour="search">
									<v-text-field
										v-model="searchfield"
										label="Cerca ticket"
										outlined
										append-icon="mdi-magnify"
										dense
										hide-details
										@click:append="getSearch"
										@keyup.enter="getSearch"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="8" data-tour="filters">
									<v-chip-group v-model="filterStatus" @change="onFilterChange">
										<v-chip
											value=""
											small
											:outlined="filterStatus !== ''"
											:color="filterStatus === '' ? 'primary' : undefined"
											:dark="filterStatus === ''"
										>Tutti</v-chip>
										<v-chip
											v-for="s in getStatuses"
											:key="s"
											:value="s"
											small
											:outlined="filterStatus !== s"
											:color="statusColor(s)"
											:dark="filterStatus === s"
										>{{ statusLabel(s) }}</v-chip>
									</v-chip-group>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getTickets"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="ticket-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.subject" :fields="campiCard(item)" style="cursor: pointer;" @click="detailItem(item)">
												<template v-slot:actions>
													<div @click.stop>
														<v-menu top eager>
															<template v-slot:activator="{ on, attrs }">
																<v-btn icon v-bind="attrs" v-on="on" color="primary" data-tour="row-menu">
																	<v-icon>mdi-dots-vertical</v-icon>
																</v-btn>
															</template>
															<v-list>
																<v-list-item link @click="detailItem(item)">
																	<v-list-item-title class="size9">Dettaglio</v-list-item-title>
																</v-list-item>
																<v-list-item link @click="deleteItem(item)">
																	<v-list-item-title class="size9">Elimina</v-list-item-title>
																</v-list-item>
															</v-list>
														</v-menu>
													</div>
												</template>
												<template v-slot:top>
													<div class="d-flex align-center mb-1">
														<v-chip x-small dark :color="statusColor(item.status)">
															{{ statusLabel(item.status) }}
														</v-chip>
													</div>
													<div v-if="shortMessage(item)" class="caption grey--text text--darken-1 mb-1">{{ shortMessage(item) }}</div>
												</template>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr
										v-for="item in items"
										:key="item._id"
										style="cursor: pointer;"
										@click="detailItem(item)"
									>
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px" @click.stop>
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="detailItem(item)">
														<v-list-item-title class="size9">Dettaglio</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td style="width: 120px;">
											<v-chip x-small dark :color="statusColor(item.status)">
												{{ statusLabel(item.status) }}
											</v-chip>
										</td>
										<td>
											<div class="font-weight-medium">{{ item.subject }}</div>
											<div class="caption grey--text text--darken-1 mt-1">{{ shortMessage(item) }}</div>
										</td>
										<td style="white-space: nowrap;">
											<div class="d-flex align-center">
												<v-avatar size="28" :color="avatarColor(userName(item))" class="mr-2">
													<span class="white--text" style="font-size: 11px;">{{ initials(userName(item)) }}</span>
												</v-avatar>
												<span class="caption">{{ userName(item) }}</span>
											</div>
										</td>
										<td style="white-space: nowrap;">
											<span class="caption">{{ formatDateTime(item.created_at) }}</span>
										</td>
										<td style="white-space: nowrap;">
											<span :title="formatDateTime(item.updated_at)" class="caption">
												{{ relativeTime(item.updated_at) }}
											</span>
										</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>

					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" :multi-line="snackbar.mode === 'multi-line'" :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false">Chiudi</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay persistent internal-activator no-click-animation transition="dialog-bottom-transition">
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormCreate>
			<FormDetail v-if="operation === 'FormDetail'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormDetail>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il ticket non potrai piu' ripristinarlo.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false">Annulla</v-btn>
					<v-btn color="primary" text @click="confirmDelete">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import moment from 'moment';
import { stripHtml } from '@/utils/richText';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createTicketsTourSteps } from './tickets-tour';

const FormCreate = () => import('@/components/tickets/Create.vue');
const FormDetail = () => import('@/components/tickets/Detail.vue');

export default {
	name: 'ManageTickets',
	setup() {
		return { tour: useTour(createTicketsTourSteps()) };
	},
	beforeDestroy() {
		this.tour.stop();
	},
	components: { FormCreate, FormDetail, TourOverlay, KeyValueCard },
	data() {
		return {
			componentKey: 0,
			snackbar: { snackbar: false, color: '', mode: '', timeout: 6000, text: '' },
			settings: {
				search: '',
				filters: { status: '' },
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			filterStatus: '',
			total: 0,
			page: 1,
			isMobile: false,
			operation: '',
			form: null,
			dialogconfirm: false,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Stato', value: 'status' },
				{ text: 'Oggetto', value: 'subject' },
				{ text: 'Richiedente', value: 'user', sortable: false },
				{ text: 'Creato', value: 'created_at' },
				{ text: 'Aggiornato', value: 'updated_at' },
			],
		};
	},
	computed: {
		...mapGetters({
			getDialog: 'settings/getDialog',
			getTickets: 'tickets/getTickets',
			getStatuses: 'tickets/getStatuses',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
	},
	watch: {
		'settings.options': {
			handler: function (val) {
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;
				this.getDataFromApi();
			},
			deep: true,
		},
	},
	mounted() {
		this.setDialog(false);
		this.fetchStatuses();
		this.getDataFromApi();
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setTicket: 'tickets/setTicket',
		}),
		...mapActions({
			fetchItems: 'tickets/asyncFetchData',
			fetchStatuses: 'tickets/fetchStatuses',
			deleteTickets: 'tickets/deleteTickets',
			destroyData: 'tickets/destroyData',
		}),
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		formatDateTime(value) {
			return value ? moment(value).format('DD/MM/YYYY HH:mm') : '';
		},
		relativeTime(value) {
			return value ? moment(value).fromNow() : '';
		},
		initials(name) {
			if (!name || name === '-') return '?';
			return name.split(' ').map(w => w[0]).join('').substring(0, 2).toUpperCase();
		},
		avatarColor(name) {
			const palette = ['indigo', 'teal', 'deep-purple', 'blue', 'green', 'orange', 'pink', 'cyan'];
			let hash = 0;
			for (let i = 0; i < (name || '').length; i++) {
				hash = name.charCodeAt(i) + ((hash << 5) - hash);
			}
			return palette[Math.abs(hash) % palette.length];
		},
		shortMessage(item) {
			const actions = item.actions || [];
			const raw = actions[0] && actions[0].message ? actions[0].message : '';
			const msg = stripHtml(raw);
			return msg.length > 70 ? msg.substring(0, 70) + '…' : msg;
		},
		statusLabel(value) {
			const labels = {
				open: 'Aperto',
				closed: 'Chiuso',
				in_progress: 'Preso in carico',
				waitingfor: 'In attesa',
				resolved_pending: 'Risolto, da confermare',
			};
			return labels[value] || value;
		},
		statusColor(value) {
			const colors = {
				open: 'success',
				closed: 'grey',
				in_progress: 'primary',
				waitingfor: 'orange',
				resolved_pending: 'deep-purple',
			};
			return colors[value] || 'primary';
		},
		userName(item) {
			const user = item.user_data && item.user_data[0];
			return user ? user.name || user.email : '-';
		},
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Richiedente', value: this.userName(item) },
				{ label: 'Creato', value: this.formatDateTime(item.created_at) },
				{ label: 'Aggiornato', value: this.relativeTime(item.updated_at) },
			];
		},
		async getSearch() {
			this.settings.search = _.size(this.searchfield) >= 2 ? this.searchfield : '';
			this.settings.options.page = 1;
			this.getDataFromApi();
		},
		onFilterChange() {
			this.settings.options.page = 1;
			this.getDataFromApi();
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.settings.filters.status = this.filterStatus || '';
				const result = await this.fetchItems(this.settings);
				this.total = result ? result.total : 0;
			} catch (err) {
				console.log(err);
			} finally {
				this.setPreload(false);
			}
		},
		createItem() {
			this.componentKey += 1;
			this.operation = 'FormCreate';
			this.setDialog(true);
		},
		detailItem(item) {
			if (!item) return;
			this.componentKey += 1;
			this.operation = 'FormDetail';
			this.setTicket(item);
			this.setDialog(true);
		},
		deleteItem(item) {
			this.form = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.form || !this.form._id) return;
			this.deleteTickets([this.form]).then(() => {
				this.form = null;
				this.getDataFromApi();
				this.snackbar = { snackbar: true, color: 'success', mode: 'multi-line', timeout: 5000, text: 'Operazione effettuata' };
			});
		},
		propSetMessages(text) {
			this.snackbar = { snackbar: true, color: 'success', mode: 'multi-line', timeout: 5000, text };
			this.operation = '';
		},
	},
	beforeUnmount() {
		this.destroyData();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.ticket-cards,
.ticket-cards tr {
	display: block;
	width: 100%;
}
.ticket-cards tr,
.ticket-cards tr:hover {
	background: transparent !important;
}
.ticket-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.ticket-cards tr:first-child td {
	padding-top: 12px !important;
}
.ticket-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.ticket-cards tr + tr td {
	padding-top: 8px !important;
}
</style>
